(function(){
    /* Model */
    var Model = Backbone.Model.extend({
         url: function(){
	        return APP_CONFIG.MEDIA_API_ROOT+"franchises/"+this.id+((this.attributes.incShows)?"/shows/":"")
        }
        ,parse:function(resp){
            //single items return differently from the api than when they are in groups
            if(resp.results){
                return resp.results;    
            }else{
                return resp;
            }
            
        }
    })
    
    /* Collection */
    var Collection = Backbone.Collection.extend({
         model  : Model
        ,url    : APP_CONFIG.MEDIA_API_ROOT+"franchises/"
    })


/* 
    API

    Use: Backbone.Radio.channel('entities').request('shows')
    
    These return a promise, so you'll want to wrap them in a $.when or something. 
    e.g. 
    $.when( Backbone.Radio.channel('entities').request('shows') )
        .done(function(data){ 
            console.log('d',data) 
        })
*/ 
    var api = Backbone.Radio.channel('entities');

    //get a single item
    api.reply('franchise',function(opts){
        var defer = $.Deferred()
            ,item = new Model(opts)
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })
    
    //get a collection
    api.reply('franchises',function(){
        var defer = $.Deferred()
            ,item = new Collection([],{})
        item.fetch({
            success:function(data){
                defer.resolve(data)
            }
            ,error:function(data){
                defer.resolve(undefined)
            }
        })
        return defer.promise();
    })

})();